import { UserRole, UserRolePrettyName } from './Dtos';

export function roleValueToPrettyName(role: string): string {
	switch (role) {
		case UserRole.ADMIN:
			return UserRolePrettyName.ADMIN;
		case UserRole.SUPERVISOR:
			return UserRolePrettyName.SUPERVISOR;
		case UserRole.RESPONSIBLE:
			return UserRolePrettyName.RESPONSIBLE;
		case UserRole.OPERATOR:
			return UserRolePrettyName.OPERATOR;
		case UserRole.REPORT:
			return UserRolePrettyName.REPORT;
		case UserRole.UNIFICATORE:
			return UserRolePrettyName.UNIFICATORE;
		default:
			return 'Da definire';
	}
}

export function getRolesPrettyName(roles?: string[]): string {
	if (roles) {
		let ruoli = '';
		roles.forEach(r => {
			ruoli += ruoli === '' ? roleValueToPrettyName(r) : ', ' + roleValueToPrettyName(r);
		});
		return ruoli;
	} else {
		return 'Da definire'
	}
}